import * as React from 'react';
import { useForm } from './useForm';
import { ContasPagarSchema } from '../schemas/ContasPagarSchema';
import ContaPagarController from '../controllers/ContaPagarController';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { debounce } from '@mui/material';
import { SelectAutoCompleteOptions } from '../shared/types/selectAutoComplete';
import FormaPagamentoController from '../controllers/FormaPagamentoController';
import CondicaoPagamentoController from '../controllers/CondicaoPagamentoController';
import CentroCustoController from '../controllers/CentroCustoController';
import CategoriaFinanceiraController from '../controllers/CategoriaFinanceiraController';
import FornecedorController from '../controllers/FornecedorController';
import { TableParcelas } from '../controllers/Types'
import { formatDateToInput } from '../shared/utils/helpers/date';

interface ContaPagarListarUnico {
  dadosgerais: DadosGerais;
  parcelas: Parcelas;
  categoria: Categoria;
  centrodecusto: CentroCusto;
  parcela_unica: ParcelaUnica;
}
interface DadosGerais {
  cp_id: number;
  parcela: string;
  cpp_id: number;
  cp_descricao: string;
  cli_nome: string;
  cp_dataemissao: Date;
  cp_dataReferencia: Date;
  cpp_datavencimento: Date;
  cpg_id: number;
  cpg_descricao: string;
  fpg_id: number;
  fpg_descricao: string;
  cpp_valor: number;
  cp_total: number;
}
interface Parcelas {
  cpp_parcela_numero: number;
  cpp_valor: number;
  cpp_datavencimento: Date;
}
interface ParcelaUnica {
  cpp_valor: number;
  cpp_vencimento: Date;
}

interface Categoria {
  catfin_id: number;
  cfi_descrição: string;
}

interface CentroCusto {
  cc_id: number;
  cc_descricao: string;
}

const useContasPagar = (id: number | null) => {
  const [activeTab, setActiveTab] = React.useState('1');
  const [loading, setLoading] = React.useState(false);
  const [single, setSingle] = useState<ContaPagarListarUnico>();
  const cpp_id = id;

  const [fornecedorOptions, setFornecedorOptions] = useState<
    SelectAutoCompleteOptions[]
  >([]);
  const [allFornecedorList, setAllFornecedorList] = useState<any[]>([]);
  const [activeFornecedorSelected, setActiveFornecedorSelected] = useState<any>({});

  const [formaPagamentoOptions, setFormaPagamentoOptions] = useState<
    SelectAutoCompleteOptions[]
  >([]);
  const [allFormaPagamentoList, setAllFormaPagamentoList] = useState<any[]>([]);
  const [activeFormaPagamentoSelected, setActiveFormaPagamentoSelected] = useState<any>({});

  const [condicaoParcelamentoOptions, setCondicaoParcelamentoOptions] = useState<
    SelectAutoCompleteOptions[]
  >([]);
  const [allCondicaoParcelamentoList, setAllCondicaoParcelamentoList] = useState<any[]>([]);
  const [activeCondicaoParcelamentoSelected, setActiveCondicaoParcelamentoSelected] = useState<any>({});

  const [categoriaOptions, setCategoriaOptions] = useState<
    SelectAutoCompleteOptions[]
  >([]);
  const [allCategoriaList, setAllCategoriaList] = useState<any[]>([]);
  const [activeCategoriaSelected, setActiveCategoriaSelected] = useState<any>({});

  const [centroCustoOptions, setCentroCustoOptions] = useState<
    SelectAutoCompleteOptions[]
  >([]);
  const [allCentroCustoList, setAllCentroCustoList] = useState<any[]>([]);
  const [activeCentroCustoSelected, setActiveCentroCustoSelected] = useState<any>({});


  React.useEffect(() => {
    if (cpp_id !== null) {
      ContaPagarController.ListarUnico(cpp_id).then((response) => {
        setSingle(response.Data);
      });
    }
  }, [cpp_id]);

  React.useEffect(() => {
    setActiveFornecedorSelected(single?.dadosgerais);
    setActiveFormaPagamentoSelected(single?.dadosgerais);
    setActiveCondicaoParcelamentoSelected(single?.dadosgerais);
  }, [single]);

  const onSubmit = async (data: any) => {
    setLoading(true);
    const result = await ContaPagarController.Adicionar(data);
    setLoading(false);
    if (result.StatusCode === 200) {
      toast('Conta a pagar cadastrada com sucesso!', {
        type: 'success',
      });
      finishOrder();
    } else {
      toast('Erro ao cadastrar conta a pagar!', {
        type: 'error',
      });
    }
    return data;
  };

  const form = useForm({
    onSubmit: onSubmit,
    initialValues: {
      dadosGerais: {
        cp_id: single?.dadosgerais.cp_id,
        descricao: single?.dadosgerais.cp_descricao || '',
        fornecedorId: single?.dadosgerais.cli_nome,
        valorTotal: single?.dadosgerais.cp_total || 0,
        dataEmissao: formatDateToInput(single?.dadosgerais.cp_dataemissao) || '',
        dataReferencia: formatDateToInput(single?.dadosgerais.cp_dataReferencia) || '',
        dataVencimento: single?.dadosgerais.cpp_datavencimento || '',
        formaPagamentoId: single?.dadosgerais.fpg_id || '',
        condicaoParcelamentoId: single?.dadosgerais.cpg_descricao || '',
        observacao: '',
        repetir: false,
        repetirValue: 2,
        tituloPago: false,
        origem: 'CONTASPAGAR',
      },
      categoria: {
        catFinanceiraId: '',
      },
      centroCusto: {
        cCustoId: '',
      },
      parcelas: single?.parcelas || [],
    },
    validationSchema: ContasPagarSchema,
  });

  const finishOrder = () => {
    setActiveTab('1');
    form.resetForm();
  }

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
  };

  const handleAdicionar = () => {
    const json = form.values;

    if (!json?.dadosGerais?.formaPagamentoId) return toast.error('Forma de Pagamento Inválida')
    if (!json?.dadosGerais?.fornecedorId) return toast.error('Fornecedor Inválido')
    if (!json?.dadosGerais?.condicaoParcelamentoId) return toast.error('Condição de Parcelamento Inválida')

    json.dadosGerais.repetir = json?.parcelas?.length === 1 && json.dadosGerais.repetir
    const ContaPagarJson = {
      ContaPagarJson: JSON.stringify(json), // Porque stringify se a API já recebe Content-Type application/json ?
      repetir: !!json.dadosGerais.repetir
    };
    onSubmit(ContaPagarJson)
  }

  // O vencimento de cada parcela vem dos prazos da condicao de parcelamento
  // (ex.: "15/20/30 DIAS" = referencia + 15, +20 e +30 dias). Antes o calculo era
  // feito aqui com addMonths(referencia, i): somava MESES e ignorava os dias
  // cadastrados, entao toda condicao que nao fosse mensal gerava vencimento errado.
  // Agora chama a mesma PROC_CONDICAOPAGAMENTO_SIMULAR_PARCELAS usada no financeiro
  // do pedido, para as duas telas gerarem exatamente as mesmas parcelas.
  const handleCalculaParcelas = async () => {
    const valorTotal = Number(form?.values?.dadosGerais?.valorTotal) || 0;
    // Na edicao, condicaoParcelamentoId recebe a descricao (cpg_descricao), nao o id -
    // por isso o id sai do item selecionado primeiro.
    const condicaoParcelamentoId = Number(
      activeCondicaoParcelamentoSelected?.cpg_id ??
        form?.values?.dadosGerais?.condicaoParcelamentoId
    );
    const dataReferencia = form?.values?.dadosGerais?.dataReferencia || '';

    if (!valorTotal) return toast.error('Valor Total Inválido')
    if (!condicaoParcelamentoId) return toast.error('Condição de Parcelamento Inválida')
    if (!/^\d{4}-\d{2}-\d{2}$/.test(dataReferencia)) return toast.error('Data de referência Inválida')

    const result = await CondicaoPagamentoController.SimularParcelas({
      CondicaoPagamentoId: condicaoParcelamentoId,
      ValorTotal: valorTotal,
      DataReferencia: dataReferencia,
      RecebimentoUnico: 'N',
      RepetirValor: 'N',
    });

    if (result.StatusCode !== 200 || !Array.isArray(result.Data)) {
      return toast.error('Não foi possível calcular as parcelas')
    }

    // A proc ja devolve o rateio (divide e joga a diferenca de centavos na ultima
    // parcela), por isso nao ha mais arredondamento no front.
    const parcelas: TableParcelas[] = result.Data.map((item: any) => ({
      cpp_parcela_numero: item.parcela_numero,
      cpp_valor: Number(item.valor),
      // A coluna da tabela e o payload de gravacao esperam 'yyyy-MM-dd' puro; sem o
      // corte a hora entraria no valor e deslocaria o dia na conversao de fuso.
      cpp_datavencimento: String(item.data_vencimento).substring(0, 10),
    }));

    onSubmitParcelas(parcelas);
  }

  const onSubmitParcelas = async (data: any) => {
    form.setFieldValue('parcelas', [
      ...data
    ]);
    toast('Parcelas geradas', { type: 'info' });
  };

  const handleSearchFornecedor = async (value: string, type: string) => {
    if (!value && !type) return;

    const fornecedores = await FornecedorController.Listar({
      Nome: value,
    });
    if (fornecedores?.Data?.length) {
      setAllFornecedorList(fornecedores.Data);
      setFornecedorOptions(
        (fornecedores?.Data || [])?.map((item: any) => {
          return {
            label: item.cli_nome,
            value: item.cli_id,
          };
        })
      );
    }
  };

  const handleAutoCompleteSelectedFornecedor = (
    value: SelectAutoCompleteOptions
  ) => {
    if (!value) return;

    const fornecedores = allFornecedorList.find((item: any) => {
      return item.cli_id === value.value;
    });

    form.setFieldValue('dadosGerais.fornecedorId', value.value);
    setActiveFornecedorSelected(fornecedores);
  };


  const handleSearchFormaPagamento = async (value: string, type: string) => {
    if (!value && !type) return;
    const formaPagamento = await FormaPagamentoController.Listar({
      FormaPagamentoId: null,
      Descricao: value,
      TipoPagamentoId: null,
      TipoUtilizacao: '',
      TipoCartao: '',
      TaxaMinima: null,
      TaxaTransAVista: null,
      QntdDiasRecebimento: null,
    });

    if (formaPagamento?.Data?.length) {
      setAllFormaPagamentoList(formaPagamento.Data);
      setFormaPagamentoOptions(
        (formaPagamento?.Data || [])?.map((item: any) => {
          return {
            label: item.fpg_descricao,
            value: item.fpg_id,
          };
        })
      );
    }
  };

  const handleAutoCompleteSelectedFormaPagamento = (
    value: SelectAutoCompleteOptions
  ) => {
    if (!value) return;

    const formaPagamento = allFormaPagamentoList.find((item: any) => {
      return item.fpg_id === value.value;
    });
    form.setFieldValue('dadosGerais.formaPagamentoId', value.value);
    setActiveFormaPagamentoSelected(formaPagamento);
  };

  const handleSearchCondicaoParcelamento = async (value: string, type: string) => {
    if (!value && !type) return;
    const condicaoParcelamento = await CondicaoPagamentoController.Listar({
      CondicaoPagamentoId: null,
      Descricao: value,
      TipoUtilizacao: '',
      TipoParcelamento: '',
      Quantidade: '',
    });

    if (condicaoParcelamento?.Data?.length) {
      setAllCondicaoParcelamentoList(condicaoParcelamento.Data);
      setCondicaoParcelamentoOptions(
        condicaoParcelamento.Data.map((item: any) => {
          return {
            label: item.cpg_descricao,
            value: item.cpg_id,
          };
        })
      );
    }
  };

  const handleAutoCompleteSelectedCondicaoParcelamento = (
    value: SelectAutoCompleteOptions
  ) => {
    if (!value) return;

    const condicaoParcelamento = allCondicaoParcelamentoList.find((item: any) => {
      return item.cpg_id === value.value;
    });

    form.setFieldValue('dadosGerais.condicaoParcelamentoId', value.value);
    setActiveCondicaoParcelamentoSelected(condicaoParcelamento);
  };

  //==========================================================================
  const handleSearchCategoria = async (value: string, type: string) => {
    if (!value && !type) return;

    const categoria = await CategoriaFinanceiraController.Listar({
      CategoriaFinanceiraId: null,
      CategoriaFinanceiraIdPai: null,
      Descricao: value,
      Tipo: '',
    });

    if (categoria?.Data?.length) {
      setAllCategoriaList(categoria.Data);
      setCategoriaOptions(
        categoria.Data.map((item: any) => {
          return {
            label: item.cfi_descricao,
            value: item.cfi_id,
          };
        })
      );
    }
  };

  const handleAutoCompleteSelectedCategoria = (
    value: SelectAutoCompleteOptions
  ) => {
    if (!value) return;

    const categoria = allCategoriaList.find((item: any) => {
      return item.cfi_id === value.value;
    });

    form.setFieldValue('categoria.catFinanceiraId', value.value);
    setActiveCategoriaSelected(categoria);
  };

  const handleSearchCentroCusto = async (value: string, type: string) => {
    if (!value && !type) return;

    const centroCusto = await CentroCustoController.Listar({
      CentroCustoId: null,
      Descricao: value,
    });

    if (centroCusto?.Data?.length) {
      setAllCentroCustoList(centroCusto.Data);
      setCentroCustoOptions(
        centroCusto.Data.map((item: any) => {
          return {
            label: item.cc_descricao,
            value: item.cc_id,
          };
        })
      );
    }
  };

  const handleAutoCompleteSelectedCentroCusto = (
    value: SelectAutoCompleteOptions
  ) => {
    if (!value) return;

    const centroCusto = allCentroCustoList.find((item: any) => {
      return item.cc_id === value.value;
    });

    form.setFieldValue('centroCusto.cCustoId', value.value);
    setActiveCentroCustoSelected(centroCusto);
  };

  const debouncedSearchFornecedor = debounce(handleSearchFornecedor, 400);
  const debouncedSearchFormaPagamento = debounce(handleSearchFormaPagamento, 400);
  const debouncedSearchCondicaoParcelamento = debounce(handleSearchCondicaoParcelamento, 400);
  const debouncedSearchCategoria = debounce(handleSearchCategoria, 400);
  const debouncedSearchCentroCusto = debounce(handleSearchCentroCusto, 400);

  return {
    activeTab,
    handleTabChange,
    loading,
    handleAdicionar,

    handleSearchFornecedor: debouncedSearchFornecedor,
    setAllFornecedorList,
    fornecedorOptions,
    activeFornecedorSelected,
    handleAutoCompleteSelectedFornecedor,

    handleSearchFormaPagamento: debouncedSearchFormaPagamento,
    setAllFormaPagamentoList,
    formaPagamentoOptions,
    activeFormaPagamentoSelected,
    handleAutoCompleteSelectedFormaPagamento,

    handleSearchCondicaoParcelamento: debouncedSearchCondicaoParcelamento,
    setAllCondicaoParcelamentoList,
    condicaoParcelamentoOptions,
    activeCondicaoParcelamentoSelected,
    handleAutoCompleteSelectedCondicaoParcelamento,

    handleSearchCategoria: debouncedSearchCategoria,
    setAllCategoriaList,
    categoriaOptions,
    activeCategoriaSelected,
    handleAutoCompleteSelectedCategoria,

    handleSearchCentroCusto: debouncedSearchCentroCusto,
    setAllCentroCustoList,
    centroCustoOptions,
    activeCentroCustoSelected,
    handleAutoCompleteSelectedCentroCusto,

    single,
    handleCalculaParcelas,

    ...form,
  };
};

export default useContasPagar;
